import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadReportProductionProducer = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: {
        width: "30%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Operadora",
    },
    {
      style: {
        width: "30%",
        textAlign: "right",
      },
      title: "Total mensalidade",
    },
    {
      style: {
        width: "20%",
        textAlign: "center",
      },
      title: "Quantidade contratos",
    },
    {
      style: {
        width: "20%",
        textAlign: "center",
      },
      title: "Quantidade vidas",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
